import PageContainer, { PageHeader } from "@/components/PageContainer";
import { ROLES } from "@/data/content";

export default function Roles() {
  return (
    <PageContainer testid="roles-page">
      <PageHeader
        overline="Part IV · Roles"
        title="Every framework is somebody's job."
        subtitle="Each role has a portfolio — the two to four frameworks they use most, and how. This prevents framework overload while making sure nothing is dropped."
      />

      <div className="grid md:grid-cols-2 gap-5" data-testid="role-cards">
        {ROLES.map((r) => (
          <article key={r.id} className="card p-6" data-testid={`role-card-${r.id}`}>
            <h3 className="text-navy text-lg font-semibold mb-3">{r.name}</h3>
            <p className="text-sm text-ink italic mb-4 leading-relaxed">{r.purpose}</p>

            <div className="grid grid-cols-1 gap-3">
              <div>
                <div className="text-xs uppercase tracking-wider text-teal font-semibold mb-1.5">Primary</div>
                <div className="flex flex-wrap gap-1.5">
                  {r.primary.map((p) => (
                    <span key={p} className="badge badge-teal">
                      {p}
                    </span>
                  ))}
                </div>
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider text-ink-muted font-semibold mb-1.5">
                  Secondary
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {r.secondary.map((p) => (
                    <span key={p} className="badge badge-neutral">
                      {p}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </PageContainer>
  );
}
